import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
        <h3>&copy; 
          <span style={{color:'cyan'}}>2</span>0<span style={{color:'cyan'}}>2</span>1 &ensp;<span style={{color:'cyan'}}>E</span>ver<span style={{color:'cyan'}}>g</span>reen
        </h3>
    </div>
  )
};

export default Footer;
